import { generateUUID } from "@/business/shared/commons/uuid/uuid";
import { ClientActions, CreateClientRequest } from "../domain/clients";
import { createCientService } from "../infrastructure/services/createClientService";

export const createClient = {
  async execute(
    identificationType: string,
    identificationNumber: string,
    company: string,
    contactName: string,
    contactEmail: string,
    contactPhone: number,
    billingEmail: string,
    isSameEmail: boolean,
  ): Promise<void> {
    const request: CreateClientRequest =
      await ClientActions().createClientRequest(
        generateUUID(),
        identificationType,
        identificationNumber,
        company,
        contactName,
        contactEmail,
        contactPhone,
        billingEmail,
        isSameEmail,
      );
    // await createCientService.execute(request);
  },
};
